import React from 'react';
import { calculateLastActive } from 'utils/date';
import Avatar from 'shared/components/avatar/Avatar';
import CheckBox from 'shared/components/check-box/CheckBox';
import './ClientCard.scss';

class ClientDefault extends React.Component {
  render() {
    const { first_name, last_name, photo, last_active, id } = this.props.client;
    const text = last_active
      ? `Last Active ${calculateLastActive(last_active)} ago`
      : 'Invited to Hybrid';

    return (
      <div className="client-card active">
        <Avatar
          src={photo}
          width="32"
          height="32"
          name={`${first_name} ${last_name}`}
          firstLetters={`${first_name[0].toUpperCase()}${last_name[0].toUpperCase()}`}
          text={text}
          url="#"
        />
        <CheckBox key={id} value={id} id={id} name="clients_id" />
      </div>
    );
  }
}

export default ClientDefault;
